import mPageCard2 from "./PageCard2.vue";
import mPageCard914 from "./PageCard914.vue";

export const Cards = {
    mPageCard2,
    mPageCard914,
}